import { useState, useEffect } from 'react';

const BREAKPOINTS = { sm: 640, md: 768, lg: 1024 };

function get(w) {
  if (w < BREAKPOINTS.md) return 'mobile';
  if (w < BREAKPOINTS.lg) return 'tablet';
  return 'desktop';
}

export function useBreakpoint() {
  const [bp, setBp] = useState(() => get(window.innerWidth));

  useEffect(() => {
    function onResize() { setBp(get(window.innerWidth)); }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    isMobile: bp === 'mobile',
    isTablet: bp === 'tablet',
    isDesktop: bp === 'desktop',
    isMobileOrTablet: bp === 'mobile' || bp === 'tablet',
  };
}
